import '../Authenticate.css';
import { Link, useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import { AuthService } from '../../../../services/AuthService';

// Where the link in the reset email lands: /user/reset-password?uid=...&token=...
// No human check here — holding a link that was emailed to the address is the proof, and a second
// check would only give it another way to fail.

export default function ResetPassword() {

    const [params] = useSearchParams();
    const uid = params.get('uid') || '';
    const token = params.get('token') || '';

    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState([]);
    const [saving, setSaving] = useState(false);
    const navigate = useNavigate();

    const linkLooksComplete = Boolean(uid && token);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors([]);
        setSaving(true);

        const result = await AuthService.makeRequest({
            urlExtension: 'user/password-reset/confirm/',
            method: 'POST',
            body: { uid, token, password },
        });
        setSaving(false);

        if (result.error) {
            // The API answers with a list under "password" for a password the rules reject, and a
            // "detail" for a link that is no longer any good.
            const found = result.data?.password || (result.data?.detail ? [result.data.detail] : null);
            setErrors(found || ['That did not work. Ask for a new link and try again.']);
            return;
        }
        navigate('/user/login', { replace: true, state: { passwordWasReset: true } });
    };

    if (!linkLooksComplete) {
        return (
            <main className='authenticate-main'>
                <h2>That link is incomplete</h2>
                <p className='authenticate-intro'>Open the link from the email exactly as it was sent, or ask for a new one.</p>
                <p className='authenticate-toggle-format'>
                    <Link className='underline' to={'/user/forgot-password'}>Send a new link</Link>
                </p>
            </main>
        );
    }

    return (
        <main className='authenticate-main'>
            <h2>Choose a new password</h2>
            <form onSubmit={handleSubmit} className='authenticate-form'>
                <label className='authenticate-form-field'>
                    <span>New password</span>
                    <br></br>
                    <div className='authenticate-form-input-container'>
                        <input className='authenticate-form-input password' type={showPassword ? 'text' : 'password'}
                               value={password} onChange={(e) => setPassword(e.target.value)} required />
                        <button className='authenticate-show-password' type='button'
                                onClick={() => setShowPassword((prev) => !prev)}>
                            {password.length > 0 ?
                                <i className={showPassword ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"}></i> :
                                <></>
                            }
                        </button>
                    </div>
                    {errors.map((message) => (
                        <p key={message}><i className="fa-solid fa-circle-info"></i> {message}</p>
                    ))}
                </label>
                <button className="btn-login" type='submit' disabled={saving}>
                    {saving ? 'Saving…' : 'Set the new password'}
                </button>
            </form>
            <p className='authenticate-toggle-format'>
                <Link className='underline' to={'/user/forgot-password'}>Ask for a new link</Link>
            </p>
        </main>
    );
}
